module.exports = __webpack_public_path__ + "static/media/bv-logo.ec47a931.png";